/* eslint-disable no-unused-vars */
import React from "react";
import axios from "axios";
import { toast } from "sonner";
import { Plus, Trash2, Home, Eye, EyeOff, RefreshCw, LogOut, Edit2, Save, X, Upload, Download, Volume2, Sparkles, Hash, Trophy, FileDown, FileUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { API, BACKEND_URL, resolveUrl, useAdmin } from "../adminShared";
import { PlacementEditor } from "../PlacementEditor";
import { VotingColumnEditor } from "../VotingColumnEditor";

export const LayoutSection = () => {
  const {
    countries, setCountries, votes, setVotes, events, setEvents,
    activeEvent, setActiveEvent, showCreateEvent, setShowCreateEvent, newEventName, setNewEventName,
    copyFromEventId, setCopyFromEventId, creatingEvent, setCreatingEvent, showRenameEvent, setShowRenameEvent,
    renameEventName, setRenameEventName, importFile, setImportFile, showImportConfirm, setShowImportConfirm,
    importing, setImporting, newCountry, setNewCountry, editingCountry, setEditingCountry,
    backgroundVideo, setBackgroundVideo, bgVideoBlur, setBgVideoBlur, bgVideoBrightness, setBgVideoBrightness, bgVideoOpacity, setBgVideoOpacity, fontTitle, setFontTitle, fontSubtitle, setFontSubtitle,
    fontCountry, setFontCountry, fontPoints, setFontPoints, fontVoting, setFontVoting,
    customFontTitleUrl, setCustomFontTitleUrl, customFontTitleName, setCustomFontTitleName, customFontSubtitleUrl, setCustomFontSubtitleUrl,
    customFontSubtitleName, setCustomFontSubtitleName, customFontCountryUrl, setCustomFontCountryUrl, customFontCountryName, setCustomFontCountryName,
    customFontPointsUrl, setCustomFontPointsUrl, customFontPointsName, setCustomFontPointsName, customFontVotingUrl, setCustomFontVotingUrl,
    customFontVotingName, setCustomFontVotingName, fontSizeTitle, setFontSizeTitle, fontSizeSubtitle, setFontSizeSubtitle,
    fontSizeCountry, setFontSizeCountry, fontSizePoints, setFontSizePoints, fontSizeVoting, setFontSizeVoting,
    primaryColor, setPrimaryColor, secondaryColor, setSecondaryColor, tertiaryColor, setTertiaryColor,
    rowBgEven, setRowBgEven, rowBgOdd, setRowBgOdd, rowBgEvenTranslucent, setRowBgEvenTranslucent, rowBgOddTranslucent, setRowBgOddTranslucent, rowBadgeTranslucent, setRowBadgeTranslucent, logoUrl, setLogoUrl,
    logoPosition, setLogoPosition, logoSize, setLogoSize, logoZIndex, setLogoZIndex,
    logoOpacity, setLogoOpacity, extraImage1Url, setExtraImage1Url, extraImage1Position, setExtraImage1Position,
    extraImage1Size, setExtraImage1Size, extraImage1ZIndex, setExtraImage1ZIndex, extraImage1Opacity, setExtraImage1Opacity,
    extraImage2Url, setExtraImage2Url, extraImage2Position, setExtraImage2Position, extraImage2Size, setExtraImage2Size,
    extraImage2ZIndex, setExtraImage2ZIndex, extraImage2Opacity, setExtraImage2Opacity, extraImage3Url, setExtraImage3Url,
    extraImage3Position, setExtraImage3Position, extraImage3Size, setExtraImage3Size, extraImage3ZIndex, setExtraImage3ZIndex,
    extraImage3Opacity, setExtraImage3Opacity, defaultArtistPhoto, setDefaultArtistPhoto, artistPhotoSizeMode, setArtistPhotoSizeMode,
    artistPhotoSizePx, setArtistPhotoSizePx, textTitle, setTextTitle, textSubtitle, setTextSubtitle,
    textVotingNow, setTextVotingNow, textWaiting, setTextWaiting, sound12PointsUrl, setSound12PointsUrl,
    confettiEnabled, setConfettiEnabled, confettiColors, setConfettiColors, top1Color, setTop1Color,
    top2Color, setTop2Color, top3Color, setTop3Color, lastPlaceColor, setLastPlaceColor,
    top1Translucent, setTop1Translucent, top2Translucent, setTop2Translucent, top3Translucent, setTop3Translucent,
    lastPlaceTranslucent, setLastPlaceTranslucent, positionBadgeTranslucent, setPositionBadgeTranslucent, votingColumnCenter, setVotingColumnCenter, leftColSpan, setLeftColSpan,
    rightColSpan, setRightColSpan, votingColSpan, setVotingColSpan, columnGap, setColumnGap,
    subtitleCounterEnabled, setSubtitleCounterEnabled, subtitlePhaseOrder, setSubtitlePhaseOrder, subtitleJuryLabel, setSubtitleJuryLabel,
    subtitleTelevoteLabel, setSubtitleTelevoteLabel, mystery12Text, setMystery12Text, mysteryHiddenPoints, setMysteryHiddenPoints, voteDisplayColumns, setVoteDisplayColumns,
    showVoterBorder, setShowVoterBorder, showJuryBadge, setShowJuryBadge, fontVotingSecondary, setFontVotingSecondary,
    fontTitleItalic, setFontTitleItalic, fontSubtitleItalic, setFontSubtitleItalic, fontCountryItalic, setFontCountryItalic,
    fontPointsItalic, setFontPointsItalic, fontVotingItalic, setFontVotingItalic, fontVotingSecondaryItalic, setFontVotingSecondaryItalic,
    customFontVotingSecondaryUrl, setCustomFontVotingSecondaryUrl, customFontVotingSecondaryName, setCustomFontVotingSecondaryName, overlay12Enabled, setOverlay12Enabled,
    overlay12DurationMode, setOverlay12DurationMode, overlay12DurationSeconds, setOverlay12DurationSeconds, overlay12BgStyle, setOverlay12BgStyle,
    overlay12BgColor, setOverlay12BgColor, overlay12BgOpacity, setOverlay12BgOpacity, overlay12TextReceives, setOverlay12TextReceives,
    overlay12UseAdminColors, setOverlay12UseAdminColors, overlay12ShowConfetti, setOverlay12ShowConfetti, overlay12Visible, setOverlay12Visible, previewGiverId, setPreviewGiverId,
    previewRecipientId, setPreviewRecipientId, winnerOverlayEnabled, setWinnerOverlayEnabled, winnerOverlayDurationMode, setWinnerOverlayDurationMode,
    winnerOverlayDurationSeconds, setWinnerOverlayDurationSeconds, winnerOverlayBgStyle, setWinnerOverlayBgStyle, winnerOverlayBgColor, setWinnerOverlayBgColor,
    winnerOverlayBgOpacity, setWinnerOverlayBgOpacity, winnerOverlayTitleText, setWinnerOverlayTitleText, winnerOverlaySubtitleText, setWinnerOverlaySubtitleText,
    winnerOverlayUseAdminColors, setWinnerOverlayUseAdminColors, winnerOverlayShowConfetti, setWinnerOverlayShowConfetti, winnerOverlayShowPoints, setWinnerOverlayShowPoints,
    winnerOverlayVisible, setWinnerOverlayVisible, overlay12StyleCustom, setOverlay12StyleCustom, overlay12FontTitle, setOverlay12FontTitle,
    overlay12FontCountry, setOverlay12FontCountry, overlay12FontSecondary, setOverlay12FontSecondary, overlay12SizeScale, setOverlay12SizeScale,
    winnerOverlayStyleCustom, setWinnerOverlayStyleCustom, winnerOverlayFontTitle, setWinnerOverlayFontTitle, winnerOverlayFontCountry, setWinnerOverlayFontCountry,
    winnerOverlayFontSecondary, setWinnerOverlayFontSecondary, winnerOverlaySizeScale, setWinnerOverlaySizeScale, loading, setLoading,
    exportingPdf, setExportingPdf, winnerPreviewId, setWinnerPreviewId, adminInitRef, adminPollRef,
    navigate, fetchCurrentVoterStatus, handleHideOverlay12, handlePreviewOverlay12, handleShowWinner, handleHideWinner,
    getFontFormat, fetchBackground, handleSetBackground, handleExportPdf, handleFileUpload, fetchCountries,
    fetchVotes, downloadFromApi, handleExportVotesPdf, handleExportVotesExcel, fetchEvents, reloadEventData,
    handleSelectEvent, handleCreateEvent, handleRenameEvent, handleExportEvent, handleImportEvent, handleAddCountry,
    handleDeleteCountry, handleSetCurrentVoter, handleResetVotes, handleLogout, handleApplyVotes, handleReveal12Points,
    handleEditCountry, handleUpdateCountry, handleToggleBadge, handleToggleTranslucent, votingCountries, juryMembers,
    votedCountries,
  } = useAdmin();
  // Convert a hex/rgba color string into a #rrggbb value usable by <input type="color">.
  const toPickerHex = (c) => {
    if (!c || typeof c !== 'string') return "#000000";
    if (c.startsWith('#')) return c.slice(0, 7).padEnd(7, '0');
    const m = c.match(/rgba?\(([^)]+)\)/i);
    if (m) {
      const parts = m[1].split(',').map((s) => parseInt(s.trim(), 10));
      const h = (n) => Math.max(0, Math.min(255, isNaN(n) ? 0 : n)).toString(16).padStart(2, '0');
      return `#${h(parts[0])}${h(parts[1])}${h(parts[2])}`;
    }
    return "#000000";
  };
  return (
    <>
                {/* Layout del Marcador */}
                <div className="p-4 bg-zinc-800/30 rounded-lg border border-zinc-700" data-testid="layout-config-section">
                  <Label className="text-zinc-300 mb-3 block font-semibold text-lg">Layout del Marcador</Label>
                  <p className="text-zinc-500 text-sm mb-4">Configura la posición de la columna de votación y el ancho de las columnas</p>
                  
                  {/* Toggle: Voting column center */}
                  <div className="flex items-center justify-between mb-5 p-3 bg-zinc-900/50 rounded-lg border border-zinc-700">
                    <div>
                      <Label className="text-zinc-300 font-semibold">Columna de votación en el centro</Label>
                      <p className="text-zinc-500 text-xs mt-1">Estilo Eurovision 2004: la columna de votación va entre las dos columnas del marcador</p>
                    </div>
                    <button
                      type="button"
                      onClick={() => setVotingColumnCenter(!votingColumnCenter)}
                      className={`relative w-14 h-7 rounded-full transition-colors shrink-0 ${
                        votingColumnCenter ? 'bg-pink-600' : 'bg-zinc-700'
                      }`}
                      data-testid="toggle-voting-center"
                    >
                      <span 
                        className={`absolute top-1 w-5 h-5 rounded-full bg-white transition-transform ${
                          votingColumnCenter ? 'translate-x-8' : 'translate-x-1'
                        }`}
                      />
                    </button>
                  </div>

                  {/* Column spans */}
                  <div className="space-y-4 mb-5">
                    <div>
                      <Label className="text-zinc-400 text-sm mb-1 block">Columna Izquierda: {leftColSpan}/12</Label>
                      <input 
                        type="range" min="2" max="7" value={leftColSpan} 
                        onChange={(e) => setLeftColSpan(Number(e.target.value))} 
                        className="w-full accent-pink-500"
                        data-testid="slider-left-col"
                      />
                    </div>
                    <div>
                      <Label className="text-zinc-400 text-sm mb-1 block">Columna de Votación: {votingColSpan}/12</Label>
                      <input 
                        type="range" min="1" max="6" value={votingColSpan} 
                        onChange={(e) => setVotingColSpan(Number(e.target.value))} 
                        className="w-full accent-cyan-500"
                        data-testid="slider-voting-col"
                      />
                    </div>
                    <div>
                      <Label className="text-zinc-400 text-sm mb-1 block">Columna Derecha: {rightColSpan}/12</Label>
                      <input 
                        type="range" min="2" max="7" value={rightColSpan} 
                        onChange={(e) => setRightColSpan(Number(e.target.value))} 
                        className="w-full accent-purple-500"
                        data-testid="slider-right-col"
                      />
                    </div>
                    <div>
                      <Label className="text-zinc-400 text-sm mb-1 block">Espaciado entre columnas: {columnGap}</Label>
                      <input 
                        type="range" min="1" max="12" value={columnGap} 
                        onChange={(e) => setColumnGap(Number(e.target.value))} 
                        className="w-full accent-zinc-400"
                        data-testid="slider-col-gap"
                      />
                    </div>
                    <p className="text-zinc-500 text-xs">
                      Total: {leftColSpan} + {votingColSpan} + {rightColSpan} = {leftColSpan + votingColSpan + rightColSpan}/12
                      {leftColSpan + votingColSpan + rightColSpan !== 12 && (
                        <span className="text-amber-400 ml-2">(Recomendado: 12)</span>
                      )}
                    </p>
                  </div>

                  {/* Mini visual preview */}
                  <div className="p-3 bg-zinc-900/80 rounded-lg border border-zinc-600">
                    <Label className="text-zinc-400 text-xs mb-2 block">Vista previa del layout:</Label>
                    <div className="flex items-stretch gap-1 h-20">
                      {votingColumnCenter ? (
                        <>
                          <div 
                            className="bg-pink-600/30 border border-pink-500/50 rounded flex items-center justify-center"
                            style={{ flex: leftColSpan }}
                          >
                            <span className="text-pink-300 text-[10px] font-bold">IZQ ({leftColSpan})</span>
                          </div>
                          <div 
                            className="bg-cyan-600/30 border border-cyan-500/50 rounded flex items-center justify-center"
                            style={{ flex: votingColSpan }}
                          >
                            <span className="text-cyan-300 text-[10px] font-bold">VOT ({votingColSpan})</span>
                          </div>
                          <div 
                            className="bg-purple-600/30 border border-purple-500/50 rounded flex items-center justify-center"
                            style={{ flex: rightColSpan }}
                          >
                            <span className="text-purple-300 text-[10px] font-bold">DER ({rightColSpan})</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div 
                            className="bg-pink-600/30 border border-pink-500/50 rounded flex items-center justify-center"
                            style={{ flex: leftColSpan }}
                          >
                            <span className="text-pink-300 text-[10px] font-bold">IZQ ({leftColSpan})</span>
                          </div>
                          <div 
                            className="bg-purple-600/30 border border-purple-500/50 rounded flex items-center justify-center"
                            style={{ flex: rightColSpan }}
                          >
                            <span className="text-purple-300 text-[10px] font-bold">DER ({rightColSpan})</span>
                          </div>
                          <div 
                            className="bg-cyan-600/30 border border-cyan-500/50 rounded flex items-center justify-center"
                            style={{ flex: votingColSpan }}
                          >
                            <span className="text-cyan-300 text-[10px] font-bold">VOT ({votingColSpan})</span>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Editor de columna de votación (ancho + colores) */}
                <VotingColumnEditor />
    </>
  );
};
